export interface AdminReport {
  id: number;
  siteName: string;
  domain: string;
  reporter: string;
  damageType: string;
  amount: string;
  status: 'pending' | 'processing' | 'completed' | 'rejected';
  date: string;
}

export const adminReports: AdminReport[] = [
  { id: 1, siteName: '카지노킹', domain: 'casino-king.com', reporter: '피해자A', damageType: '출금 전 추가 입금 요구', amount: '500', status: 'pending', date: '2026.07.03' },
  { id: 2, siteName: '골든슬롯', domain: 'golden-slot.xyz', reporter: '익명', damageType: '계좌차단 및 연락 두절', amount: '1,200', status: 'processing', date: '2026.07.02' },
  { id: 3, siteName: '스포츠월드', domain: 'sports-world.biz', reporter: '제보자B', damageType: '사이트 주소 번복 변경', amount: '350', status: 'completed', date: '2026.07.01' },
  { id: 4, siteName: '탑스피드', domain: 'top-speed.cc', reporter: '먹튀싫어', damageType: '출금 전 추가 입금 요구', amount: '800', status: 'pending', date: '2026.06.30' },
  { id: 5, siteName: '로얄팰리스', domain: 'royal-palace.gg', reporter: '긴급제보', damageType: '개인정보 요구 및 유출 위협', amount: '2,000', status: 'processing', date: '2026.06.29' },
  { id: 6, siteName: '다이아몬드', domain: 'diamond-casino.vip', reporter: '익명', damageType: '입금 후 사이트 폐쇄', amount: '650', status: 'completed', date: '2026.06.28' },
  { id: 7, siteName: '판타지아', domain: 'fantasia-game.net', reporter: '슬롯매니아', damageType: '환전 지연 및 거부', amount: '430', status: 'rejected', date: '2026.06.27' },
  { id: 8, siteName: '제트카지노', domain: 'jet-casino.co', reporter: '피해자C', damageType: '멤버십 고객센터 사칭', amount: '1,500', status: 'pending', date: '2026.06.26' },
];

export interface AdminMember {
  id: number;
  email: string;
  nickname: string;
  joinDate: string;
  reportCount: number;
  postCount: number;
  points: number;
  status: 'active' | 'suspended' | 'banned';
}

export const adminMembers: AdminMember[] = [
  { id: 1, email: 'user1@email.com', nickname: '먹튀싫어', joinDate: '2026.05.12', reportCount: 12, postCount: 45, points: 2840, status: 'active' },
  { id: 2, email: 'user2@email.com', nickname: '검증마스터', joinDate: '2026.04.03', reportCount: 8, postCount: 132, points: 5670, status: 'active' },
  { id: 3, email: 'user3@email.com', nickname: '피해자모임', joinDate: '2026.06.20', reportCount: 3, postCount: 18, points: 920, status: 'active' },
  { id: 4, email: 'spam@email.com', nickname: '광고왕', joinDate: '2026.06.15', reportCount: 0, postCount: 87, points: 120, status: 'suspended' },
  { id: 5, email: 'bad@email.com', nickname: '허위제보자', joinDate: '2026.05.28', reportCount: 15, postCount: 23, points: 0, status: 'banned' },
  { id: 6, email: 'user4@email.com', nickname: '슬롯매니아', joinDate: '2026.03.15', reportCount: 5, postCount: 67, points: 3450, status: 'active' },
  { id: 7, email: 'user5@email.com', nickname: '베테랑', joinDate: '2026.02.10', reportCount: 22, postCount: 256, points: 8920, status: 'active' },
  { id: 8, email: 'user6@email.com', nickname: '초보자', joinDate: '2026.07.01', reportCount: 1, postCount: 3, points: 150, status: 'active' },
];

export interface AdminBoardCategory {
  id: number;
  name: string;
  slug: string;
  postCount: number;
  sortOrder: number;
  active: boolean;
}

export const adminBoardCategories: AdminBoardCategory[] = [
  { id: 1, name: '공지사항', slug: 'notice', postCount: 45, sortOrder: 1, active: true },
  { id: 2, name: '커뮤니티', slug: 'community', postCount: 1234, sortOrder: 2, active: true },
  { id: 3, name: '검증요청', slug: 'verify-request', postCount: 567, sortOrder: 3, active: true },
  { id: 4, name: '피해사례', slug: 'damage-cases', postCount: 892, sortOrder: 4, active: true },
  { id: 5, name: '정보공유', slug: 'info-share', postCount: 345, sortOrder: 5, active: true },
  { id: 6, name: '질문과답변', slug: 'qna', postCount: 678, sortOrder: 6, active: true },
  { id: 7, name: '이벤트', slug: 'event', postCount: 23, sortOrder: 7, active: false },
];

export interface AdminPost {
  id: number;
  title: string;
  category: string;
  author: string;
  date: string;
  views: number;
  comments: number;
  status: 'published' | 'hidden' | 'reported';
}

export const adminPosts: AdminPost[] = [
  { id: 1, title: '새로운 사이트 먹튀 검증 결과 공개', category: '커뮤니티', author: '운영팀', date: '2026.07.03', views: 1023, comments: 56, status: 'published' },
  { id: 2, title: '출금 요청했는데 계속 추가 입금만 요구하네요', category: '피해사례', author: '피해자A', date: '2026.07.03', views: 567, comments: 28, status: 'published' },
  { id: 3, title: '최근 먹튀 사이트 패턴 분석 공유합니다', category: '정보공유', author: '분석가', date: '2026.07.03', views: 892, comments: 45, status: 'published' },
  { id: 4, title: '비아그라 특가 판매합니다 클릭!', category: '커뮤니티', author: '스패머', date: '2026.07.02', views: 234, comments: 12, status: 'reported' },
  { id: 5, title: '계좌 차단 당하고 연락 두절됐습니다 도와주세요', category: '피해사례', author: '긴급제보', date: '2026.07.02', views: 1456, comments: 67, status: 'published' },
  { id: 6, title: 'xxx사이트 이용후기 (내용 미리보기 불가)', category: '검증요청', author: '익명', date: '2026.07.01', views: 89, comments: 3, status: 'hidden' },
];

export interface AdminBanner {
  id: number;
  title: string;
  position: string;
  linkUrl: string;
  startDate: string;
  endDate: string;
  active: boolean;
}

export const adminBanners: AdminBanner[] = [
  { id: 1, title: '안전사이트 이용 가이드', position: '메인 상단', linkUrl: '/board', startDate: '2026.07.01', endDate: '2026.08.01', active: true },
  { id: 2, title: '피해 제보 이벤트', position: '메인 하단', linkUrl: '/report', startDate: '2026.07.01', endDate: '2026.07.31', active: true },
  { id: 3, title: '신규 보증업체 안내', position: '사이드바', linkUrl: '/search', startDate: '2026.06.15', endDate: '2026.07.15', active: false },
];

export interface AdminGuarantee {
  id: number;
  companyName: string;
  siteName: string;
  domain: string;
  guaranteeAmount: string;
  startDate: string;
  endDate: string;
  status: 'active' | 'expired' | 'pending';
}

export const adminGuarantees: AdminGuarantee[] = [
  { id: 1, companyName: '안전보증(주)', siteName: '프리미엄카지노', domain: 'premium-casino.co.kr', guaranteeAmount: '1억원', startDate: '2026.06.01', endDate: '2026.12.01', status: 'active' },
  { id: 2, companyName: '믿음보증', siteName: '베가스파크', domain: 'vegas-park.io', guaranteeAmount: '5천만원', startDate: '2026.05.15', endDate: '2026.11.15', status: 'active' },
  { id: 3, companyName: '한국보증협회', siteName: '파워볼존', domain: 'powerball-zone.net', guaranteeAmount: '8천만원', startDate: '2026.04.01', endDate: '2026.06.30', status: 'expired' },
  { id: 4, companyName: '신뢰보증(주)', siteName: '메이저리그', domain: 'major-league.bz', guaranteeAmount: '1.5억원', startDate: '2026.07.01', endDate: '2027.01.01', status: 'active' },
];

export interface AdminNotice {
  id: number;
  title: string;
  content: string;
  category: string;
  date: string;
  pinned: boolean;
  status: 'published' | 'draft';
}

export const adminNotices: AdminNotice[] = [
  { id: 1, title: '스카연 앱 다운로드 안내 및 설치 방법', content: '앱 다운로드 관련 상세 내용...', category: '공지', date: '2026.07.01', pinned: true, status: 'published' },
  { id: 2, title: '커뮤니티 이용 규정 및 주의사항 안내', content: '이용 규정 관련 상세 내용...', category: '공지', date: '2026.06.28', pinned: true, status: 'published' },
  { id: 3, title: '검증 기준 변경 및 신규 기능 업데이트 안내', content: '업데이트 관련 상세 내용...', category: '업데이트', date: '2026.06.25', pinned: false, status: 'published' },
  { id: 4, title: '7월 신규 이벤트 계획 (초안)', content: '이벤트 계획 초안...', category: '이벤트', date: '2026.06.30', pinned: false, status: 'draft' },
];

export const adminDashboardStats = {
  totalMembers: 3847,
  newMembersToday: 23,
  totalReports: 521,
  pendingReports: 47,
  totalPosts: 4521,
  postsToday: 89,
  totalVerifiedSites: 234,
  activeGuarantees: 3,
};

export const adminMenuItems = [
  { key: 'overview', label: '대시보드', icon: 'ri-dashboard-line' },
  { key: 'verification', label: '검증 관리', icon: 'ri-shield-check-line' },
  { key: 'reports', label: '제보 관리', icon: 'ri-alert-line' },
  { key: 'members', label: '회원 관리', icon: 'ri-user-settings-line' },
  { key: 'board', label: '게시판 관리', icon: 'ri-price-tag-3-line' },
  { key: 'posts', label: '게시물 관리', icon: 'ri-article-line' },
  { key: 'banner', label: '배너 관리', icon: 'ri-image-line' },
  { key: 'guarantee', label: '보증업체 관리', icon: 'ri-building-line' },
  { key: 'notices', label: '공지사항 관리', icon: 'ri-megaphone-line' },
  { key: 'postReports', label: '게시글 신고 관리', icon: 'ri-flag-line' },
  { key: 'points', label: '포인트 관리', icon: 'ri-coin-line' },
  { key: 'settings', label: '사이트 설정', icon: 'ri-settings-3-line' },
];